import { render, staticRenderFns } from "./CheckResultDialog.vue?vue&type=template&id=88484a94&scoped=true&"
import script from "./CheckResultDialog.vue?vue&type=script&lang=js&"
export * from "./CheckResultDialog.vue?vue&type=script&lang=js&"
import style0 from "./CheckResultDialog.vue?vue&type=style&index=0&id=88484a94&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88484a94",
  null
  
)

export default component.exports